fx.ns("desktop.calendar", class CalendarTextEditPanel extends shared.screens.BaseChoiceScreen {
    constructor() {
        super();

        this.destroyOnSwitch = true;

        this.showNext = false;
        this.showBack = true;
        this.mode = "";

        this.showEffect = "fade";
        this.hideEffect = "fade"

        this.containerHeight = 600;
    }

    get data() {
        return super.data;
    }

    set data(val) {
        if (val && val.data && val.day) {
            super.data = val.data;
            this._model = val.model;
            this._day = val.day;
            this.cellWidth = val.cellWidth;
            this.cellHeight = val.cellHeight;
        }
        else
            super.data = val;

    }

    get model()
    {
        return this._model;
    }

    get day() {
        return this._day;
    }


    get text() {
        if (this.data) {
            let content = JSON.parse(this.data.content);
            return content.days[this.day];
        }
        else
            return "";
    }

    set text(val) {
        let content = JSON.parse(this.data.content);
        content.days[this.day] = val;
        this.data.content = JSON.stringify(content);
    }

    create() {
        super.create();

        this.calendarCell = new shared.stage.CalendarCell(this.data, this.day, this.model);
        this.addChild(this.calendarCell, { left: "center", top: "center", width: this.cellWidth, height: this.cellHeight });
        this.calendarCell.css({ border: "solid " + 0.5 * this._model.creation.extraScale + "px #C6DAE1" });
        this.calendarCell.css({ borderRadius: 2 * this._model.creation.extraScale + "px" });
        this.calendarCell.css("transform", "scale(" + (this._model.creation.extraScale ? (10 / this._model.creation.extraScale) : 10) + ")");

        this.validateButton = new fx.components.Box("exit");
        this.validateButton.effect = "fade";
        let button = new fx.components.IconButton({ icon: fx.assets.checkmark, className: "exit" });
        this.validateButton.addChild(button, { right: 0, top: 10, width: 40, height: 40 });

        let exitLabel = new fx.components.Text({ text: fx.text("Valider"), className: "button-label link left-label" });
        this.validateButton.addChild(exitLabel, { width: 100, height: 40, right: 40, top: 20 });

        this.addChild(this.validateButton, { top: 10, right: 20, width: 30, height: 30 });
    }

    onReady() {
        super.onReady();

        this.on("click", this.onValidate, this.validateButton);

        this.delay(this.focusOnCell, 500);
    }

    focusOnCell() {
        this.calendarCell.focus();
    }

    onBack() {
        this.data.event("show-editor");
    }

    onValidate() {
        this.text = this.calendarCell.currentText;

        this.data.event("show-editor");
    }


});